import React from "react";
import { CURRENCY } from "../../../contants";

const ActionButtons = ({
  currentOrder,
  orderItemsGrouped,
  handleKot,
  tableType,
  finalGrandTotal,
  onBillClick,
  onPrintBillClick,
  onSettleClick,
}) => {
  const isDisabled =
    !currentOrder || orderItemsGrouped.every((kot) => kot.items.length === 0);

  return (
    <div className="p-3 border-top action-buttons d-flex justify-content-between">
      <div className="row mx-0">
        <div className="col p-0">
          <button
            className="btn btn-primary btn-sm w-100 d-flex align-items-center justify-content-center"
            onClick={() => handleKot(tableType, false)}
            disabled={isDisabled}
          >
            <i className="mdi mdi-silverware-fork-knife mr-1"></i>
            KOT
          </button>
        </div>
        <div className="col p-0">
          <button
            className="btn btn-primary btn-sm w-100 d-flex align-items-center justify-content-center"
            onClick={onBillClick}
            disabled={isDisabled}
          >
            <i className="mdi mdi-receipt mr-1"></i>
            Bill
          </button>
        </div>

        <div className="w-100"></div>
        <div className="col p-0">
          <button
            className="btn btn-primary btn-sm w-100 d-flex align-items-center justify-content-center"
            onClick={() => handleKot(tableType, true)}
            disabled={isDisabled}
          >
            <i className="mdi mdi-printer mr-1"></i>
            Print+KOT
          </button>
        </div>
        <div className="col p-0">
          <button
            className="btn btn-primary btn-sm w-100 d-flex align-items-center justify-content-center"
            onClick={onPrintBillClick}
            disabled={isDisabled}
          >
            <i className="mdi mdi-printer mr-1"></i>
            Print+Bill
          </button>
        </div>
      </div>
      <div className="settle">
        <button
          className="btn btn-success btn-sm h-100 w-100 d-flex border-0 flex-column align-items-center justify-content-center"
          onClick={onSettleClick}
          disabled={isDisabled}
        >
          <span className="font-weight-bold title">Settle</span>
          <span className="font-weight-bold total">
            {CURRENCY}
            {(finalGrandTotal || 0).toFixed(2)}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;
